/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var localize = require('./localize.service');
var rootScope = require('./root-scope.service');
var errorTemplate = require('../../templates').errorTemplate;
var loading = require('./loading.service');

function createOperation(formContainer, networkCode, withCheckbox, checked) {
    const wrapper = $('<div class="registration options"></div>');
    const label = $(
        `<label for="${networkCode}-registration">${localize.translate(
            'networks.registration.label',
            rootScope.getPageTranslation()
        )}</label>`
    );
    if (withCheckbox) {
        const checkbox = $(`<input type="checkbox" id="${networkCode}-registration">`);
        checkbox.attr('checked', checked);
        wrapper.append(checkbox);
    }
    wrapper.append(label);
    formContainer.append(wrapper);
}

function showTextOnly(formContainer, networkCode) {
    createOperation(formContainer, networkCode, false, false);
}

function showTextAndCheckbox(formContainer, networkCode) {
    createOperation(formContainer, networkCode, true, false);
}

function showTextAndSelectedCheckbox(formContainer, networkCode) {
    createOperation(formContainer, networkCode, true, true);
}

function addOperationOptions(network, formContainer) {
    if (!rootScope.isRegistrationOptionsCombined()) {
        // show separated operation options
        addSeparatedOperationOptions(network, formContainer, 'allow', 'Recurrence');
        addSeparatedOperationOptions(network, formContainer, 'auto', 'Registration');
        return;
    }

    if(rootScope.isUpdate()) return;

    // show combined operation options
    const registration = network['registration'];
    const recurrence = network['recurrence'];
    const networkCode = network['code'];

    // needed for PCX-2661 klarna exception
    if (registration === 'NONE') {
        if (recurrence === 'OPTIONAL') {
            showTextAndCheckbox(formContainer, networkCode);
            return;
        }
        if (recurrence === 'FORCED_DISPLAYED') {
            showTextOnly(formContainer, networkCode);
            return;
        }
        if (recurrence === 'OPTIONAL_PRESELECTED') {
            showTextAndSelectedCheckbox(formContainer, networkCode);
            return;
        }

        // for recurrence NONE or FORCED, nothing needs to be displayed
    }
    if (registration === 'FORCED') {
        if (recurrence !== 'FORCED' && recurrence !== 'NONE') {
            showOperationError(registration, recurrence, networkCode);
            return;
        }
        //show nothing
    }
    if (registration === 'FORCED_DISPLAYED') {
        if (recurrence !== 'FORCED_DISPLAYED' && recurrence !== 'NONE') {
            showOperationError(registration, recurrence, networkCode);
            return;
        }
        //show text only
        showTextOnly(formContainer, networkCode);
    }
    if (registration === 'OPTIONAL') {
        if (recurrence !== 'OPTIONAL' && recurrence !== 'NONE') {
            showOperationError(registration, recurrence, networkCode);
            return;
        }
        //show text and checkbox(unselected)
        showTextAndCheckbox(formContainer, networkCode);
    }
    if (registration === 'OPTIONAL_PRESELECTED') {
        if (recurrence !== 'OPTIONAL_PRESELECTED' && recurrence !== 'NONE') {
            return /*error*/;
        }
        //show text and checkbox(selected)
        showTextAndSelectedCheckbox(formContainer, networkCode);
    }
}

function showOperationError(registration, recurrence, networkCode) {
    const message =
        'Unsupported combination of autoRegistration (' +
        registration +
        ') ' +
        'and allowRecurrence (' +
        recurrence +
        ') ' +
        'for Network (' +
        networkCode +
        ')';
    rootScope.getListContainer().html(errorTemplate(message, rootScope.getTemplateName()));
    rootScope.getSubmitButton().hide();
    loading.hideFullPageLoading();
    throw new Error(message);
}

/**
 * Adds allowRecurrence and autoRegistration options as checkboxes to the HTML form.
 *
 * @param network The network that the operations will be added to
 * @param formContainer The container where the checkbox will be added to
 * @param prefix The prefix for the type
 * @param type The type of operation
 */
function addSeparatedOperationOptions(network, formContainer, prefix, type) {
    var lowerCaseType = type.toLowerCase();

    if (network[lowerCaseType] && network[lowerCaseType] != 'NONE') {
        switch (network[lowerCaseType]) {
            case 'OPTIONAL':
                rootScope.setSeparatedOperation(network.code, prefix + type, false);
                createSeparatedCheckbox(network.code, formContainer, prefix, type);
                break;
            case 'OPTIONAL_PRESELECTED':
                rootScope.setSeparatedOperation(network.code, prefix + type, true);
                createSeparatedCheckbox(network.code, formContainer, prefix, type, true);
                break;
            case 'FORCED':
                rootScope.setSeparatedOperation(network.code, prefix + type, true);
                createSeparatedCheckbox(network.code, formContainer, prefix, type, true, true, true);
                break;
            case 'FORCED_DISPLAYED':
                rootScope.setSeparatedOperation(network.code, prefix + type, true);
                createSeparatedCheckbox(network.code, formContainer, prefix, type, true, true);
                break;
        }
    }
}
/**
 * Creates an operation option
 * There are different cases,
 * first, when the checkbox and its label are displayed, it can be pre-checked or not
 * second, when the checkout and the label both are hidden,
 * third when only the checkbox is hidden but the label is visible
 *
 * @param code The network code
 * @param formContainer The container where the checkbox will be added to
 * @param prefix The prefix for the type
 * @param type The type of operation
 * @param checked Whether the checkbox should be checked or not
 * @param forced Whether the option is forced
 * @param hidden Whether the checkbox should be hidden or not
 */
function createSeparatedCheckbox(code, formContainer, prefix, type, checked, forced, hidden) {
    var wrapper = $('<div class="registration options"></div>');
    var checkbox = $('<input type="checkbox" id="' + code + type + '">');
    var labelTranslationKey = 'networks.' + type.toLowerCase() + '.' + (forced ? 'forced' : 'optional') + '.label';
    var label = $(
        '<label for="' + code + type + '">' + localize.translate(labelTranslationKey, rootScope.getPageTranslation()) + '</label>'
    );
    checkbox.attr('checked', checked);
    if (forced) {
        checkbox.hide(); // hide only the checkbox FORCED_DISPLAYED
    }
    if (hidden) {
        wrapper.hide(); // hide checkbox and label FORCED
    }
    checkbox.on('click', function () {
        rootScope.setSeparatedOperation(rootScope.getSelectedNetworkCode(), prefix + type, checkbox.is(':checked'));
    });
    wrapper.append(checkbox);
    wrapper.append(label);
    formContainer.append(wrapper);
}

module.exports = addOperationOptions;
